// src/onboarding/ui/formatDate.js — a backend timestamp (`isoformat()`, e.g. "…11.512345+00:00") as a
// short local date + time. Parsed, never compared as a string; '' when absent or unparseable.
export function formatDate(iso, language) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString(language === 'en' ? 'en-GB' : 'it-IT', { dateStyle: 'short', timeStyle: 'short' });
}
